export const OPERATIONS_TABLE_SUCCESS = 'OPERATIONS/TABLE_SUCCESS'
export const OPERATIONS_TABLE_FAILURE = 'OPERATIONS/TABLE_FAILURE'